import type { ReactElement } from 'react';
import type { AttachmentProps } from './types';
import { AttachmentError } from './error/error';
import { AttachmentProcessing } from './processing/processing';
import { AttachmentUploaded } from './uploaded/uploaded';
import { AttachmentUploading } from './uploading/uploading';
import { AttachmentWarning } from './warning/warning';

export function Attachment(props: AttachmentProps): ReactElement {
  switch (props.status) {
    case 'error':
      return <AttachmentError {...props} />;
    case 'processing':
      return <AttachmentProcessing {...props} />;
    case 'uploaded':
      return <AttachmentUploaded {...props} />;
    case 'uploading':
      return <AttachmentUploading {...props} />;
    case 'warning':
      return <AttachmentWarning {...props} />;
    default: {
      const _exhaustive: never = props;
      return _exhaustive;
    }
  }
}
